// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from "axios";
var config = require("../js/config.js");
var utils = require("./utility/utility.js");

// 默认请求公共地址、头部信息
var domainUrl = config.address;
var commomHeaders = config.commomHeaders;

// post请求
var post = function(url, data, option) {
  data = data || "";
  // 判断本地存储token是否存在
  let localUserInfo = utils.localUserInfo;
  if (localUserInfo.getItem()) {
    // console.log(localUserInfo.getItem())
    commomHeaders.Authorization = localUserInfo.getItem().apitoken;
  }
  // console.log('commomHeaders', commomHeaders)
  return new Promise(function(resolve, reject) {
    let timeout = 15 * 1000;
    if (typeof option == 'object' && typeof option['timeout'] != 'undefined' ) {
      timeout = option.timeout;
    }
    axios.defaults.timeout = timeout;
    axios({
      method: "post",
      url: domainUrl + url,
      headers: commomHeaders,
      data: data
    })
      .then(function(res) {
        // console.log('res.data', res.data)
        // 用户token过期，提示用户重新登录
        if (res.data.meta.code === 401) {
          utils.showToast("登录已过期！请重新登录");
          // 登录过期，清空缓存数据
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
          return false;
        }
        resolve(res.data);
      })
      .catch(function(error) {
        console.log(error.message);
        if (error.message.includes("timeout")) {
          utils.hideLoading();
          utils.showToast("网络超时了，请重试");
          reject(error);
        } else {
          utils.hideLoading();
          utils.showToast("连接服务器失败，取消操作请重试！");
          console.log("error", error);
          reject(error);
        }
      });
  });
};

// multipart/form-data格式的post请求
let formDataPost = function(url, data) {
  data = data || "";
  let headers = {
    "Content-Type": "multipart/form-data"
  };
  // 判断本地存储token是否存在
  let localUserInfo = utils.localUserInfo;
  if (localUserInfo.getItem()) {
    // console.log(localUserInfo.getItem())
    headers.Authorization = localUserInfo.getItem().apitoken;
  }
  console.log("headers", headers);

  return new Promise(function(resolve, reject) {
    axios({
      method: "post",
      url: domainUrl + url,
      headers: headers,
      data: data
    })
      .then(function(res) {
        // console.log('res.data', res.data)
        // 用户token过期，提示用户重新登录
        if (res.data.meta.code === 401) {
          utils.showToast("登录已过期！请重新登录");
          // 登录过期，清空缓存数据
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
          return false;
        }
        resolve(res.data);
      })
      .catch(function(error) {
        utils.hideLoading();
        utils.showToast("连接服务器失败，取消操作请重试！");
        console.log("error", error);
        reject(error);
      });
  });
};

// 公共post请求
var commonPost = function(url, data) {
  data = data || "";
  // 判断本地存储token是否存在
  let localUserInfo = utils.localUserInfo;
  if (localUserInfo.getItem()) {
    commomHeaders.Authorization = localUserInfo.getItem().apitoken;
  }

  return new Promise(function(resolve, reject) {
    axios({
      method: "post",
      url: config.commonAddress + url,
      headers: commomHeaders,
      data: data
    })
      .then(function(res) {
        // console.log('res.data', res.data)
        // 用户token过期，提示用户重新登录
        if (res.data.meta.code === 401) {
          utils.showToast("登录已过期！请重新登录");
          // 登录过期，清空缓存数据
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
          return false;
        }
        resolve(res.data);
      })
      .catch(function(error) {
        utils.hideLoading();
        utils.showToast("连接服务器失败，取消操作请重试！");
        console.log("error", error);
        reject(error);
      });
  });
};

/** 4.0s接口请求 */

// 4.0s-post请求
var post4s = function(url, data) {
  data = data || "";
  // 判断本地存储token是否存在
  let localUserInfo = utils.localUserInfo;
  if (localUserInfo.getItem()) {
    // console.log(localUserInfo.getItem())
    commomHeaders.Authorization = localUserInfo.getItem().apitoken;
  }
  // console.log('commomHeaders', commomHeaders)

  return new Promise(function(resolve, reject) {
    axios({
      method: "post",
      url: config.commonAddress4S + url,
      headers: commomHeaders,
      data: data
    })
      .then(function(res) {
        // console.log('res.data', res.data)
        // 用户token过期，提示用户重新登录
        if (res.data.ErrCode === 401) {
          utils.showToast("登录已过期！请重新登录");
          // 登录过期，清空缓存数据s
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
          return false;
        }
        resolve(res.data);
      })
      .catch(function(error) {
        utils.hideLoading();
        utils.showToast("连接服务器失败，取消操作请重试！");
        console.log("error", error);
        reject(error);
      });
  });
};

// 4.0s- multipart/form-data格式的post请求
let formDataPost4s = function(url, data) {
  data = data || "";
  let headers = {
    "Content-Type": "multipart/form-data"
  };
  // 判断本地存储token是否存在
  let localUserInfo = utils.localUserInfo;
  if (localUserInfo.getItem()) {
    // console.log(localUserInfo.getItem())
    headers.Authorization = localUserInfo.getItem().apitoken;
  }
  console.log("headers", headers);

  return new Promise(function(resolve, reject) {
    axios({
      method: "post",
      url: config.commonAddress4S + url,
      headers: headers,
      data: data
    })
      .then(function(res) {
        // console.log('res.data', res.data)
        // 用户token过期，提示用户重新登录
        if (res.data.ErrCode === 401) {
          utils.showToast("登录已过期！请重新登录");
          // 登录过期，清空缓存数据
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
          return false;
        }
        resolve(res.data);
      })
      .catch(function(error) {
        utils.hideLoading();
        utils.showToast("连接服务器失败，取消操作请重试！");
        console.log("error", error);
        reject(error);
      });
  });
};

export { post, formDataPost, commonPost, post4s, formDataPost4s };



//////////////////
// WEBPACK FOOTER
// ./static/js/request.js
// module id = tY+N
// module chunks = 1